import { useEffect } from 'react';

import type { UserProfileI } from 'declarations/interfaces/user';
import { initializePendo } from 'helpers/pendo';

/**
 * Hook to initialize Pendo when user profile is loaded
 */
export const usePendo = (userProfile: UserProfileI | null, isReady: boolean): void => {
  useEffect(() => {
    if (!userProfile || !isReady) {
      return;
    }

    // Wait for Pendo to be loaded
    const checkPendoLoaded = setInterval(() => {
      if (window.pendo) {
        clearInterval(checkPendoLoaded);
        initializePendo(userProfile);
      }
    }, 100);

    // Cleanup interval after 10 seconds if Pendo hasn't loaded
    const timeout = setTimeout(() => {
      clearInterval(checkPendoLoaded);
    }, 10000);

    return () => {
      clearInterval(checkPendoLoaded);
      clearTimeout(timeout);
    };
  }, [userProfile, isReady]);
};
